import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import moment from "moment-timezone";
import { DateRangePicker } from "react-dates";

import { Row } from "../../components/Layout";
import NTMButton from "../../components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import Charts from "containers/Data/Charts";

import { useGetDevices, getStatisticalData } from "../../service/AgrismartService";
import styles from "./_agrismart.module.scss";


export default function AveragePage({ type = 'stats' }) {

	let { devices } = useGetDevices()
	let [device, setDevice] = useState();
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	let [focusedInput, setFocusedInput] = useState();
	let [data, setData] = useState([])
	let buttonRef = useRef();

	useEffect(() => {
		if (!device && devices?.length > 0) {
			setDevice(devices[0].device)
		}
		else if (startDate && endDate) {
			let start = moment(startDate).format("DD-MM-YYYY");
			let end = moment(endDate).format("DD-MM-YYYY");
			getStatisticalData(device, start, end, type).then(setData)
		}
	}, [device, devices, startDate, endDate, type])

	if (devices.length === 0) return null

	return <div className="animated fadeIn">
		<Row className={styles.box}>
			<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
				{devices.map(d =>
					<option key={d.device} value={d.device}>{d.label || d.device}</option>
				)
				}
			</NTMSelect>
			<div data-tip data-for='global' data-event='click' ref={buttonRef}>
				<NTMButton primary>
					{
						startDate ?
							`${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`
							:
							<>Scegli Periodo&nbsp;<i className="fa fa-caret-down" aria-hidden="true" /></>
					}
				</NTMButton>
			</div>
			<ReactTooltip
				id='global'
				aria-haspopup='true'
				effect='solid'
				place={"bottom"}
				clickable
				getContent={() => <DateRangePicker
					startDate={startDate} // momentPropTypes.momentObj or null,
					startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
					endDate={endDate} // momentPropTypes.momentObj or null,
					endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
					onDatesChange={({ startDate, endDate }) => {
						setStartDate(startDate)
						setEndDate(endDate)
						if (startDate && endDate) {
							buttonRef.current.click();
						}
					}} // PropTypes.func.isRequired,
					focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
					onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
					withPortal={true}
					startDatePlaceholderText={"Inizio"}
					endDatePlaceholderText={"Fine"}
					displayFormat={"DD/MM/YYYY"}
					isOutsideRange={(o) => o.isAfter(moment(), 'day')}
					small={true}
				/>}
			/>
		</Row>
		<div style={{ margin: "1rem auto" }}>
			<Charts data={data} type={type || 'statistics'} />
		</div>
	</div>
}
